import styled, { css } from 'styled-components';
import { fsCyan, monokaiBackground, darkModeBackground, colors } from 'global/colors';

export const FreecodePlayerBackground = styled.div`
  ${({ isPopOut }) =>
    isPopOut &&
    css`
      position: fixed; !important;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.15);
      z-index: 100;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
    `}
`;

export const FreecodePlayerContainer = styled.div`
  ${({ isPopOut }) =>
    isPopOut &&
    css`
      border-radius: 5px 5px 0px 0px;
      box-shadow: 0px 15px 30px 5px rgba(50, 50, 50, 0.5);
    `}
  ${({ isPopOut, isDarkMode }) => {
    if (isPopOut && isDarkMode) {
      // using rgba to get opacity
      return css`
        background: rgba(21, 21, 21, 0.95);
        border: 1px solid ${fsCyan};
      `;
    } else if (isPopOut) {
      return css`
        background: rgba(255, 255, 255, 0.95);
      `;
    } else if (isDarkMode) {
      return css`
        background: ${darkModeBackground};
      `;
    }
  }}
`;

export const CanvasContainer = styled.div`
  width: 100%;
  height: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ isDarkMode }) =>
    css`
      background: ${isDarkMode ? monokaiBackground : colors.white};
    `}
`;

export const CanvasHolder = styled.div`
  overflow: hidden;
  ${({ width, height }) => css`
    width: ${width}px;
    height: ${height}px;
  `}
`;

export const FreecodeCanvas = styled.canvas`
  vertical-align: bottom;
`;
